import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { STEPS_CONTENT } from '../../../constants/customerOnboarding';

import IconClose from '../../../../images/icons/misc/close-black.svg';

import styles from './Card.module.scss';

const Card = forwardRef((props, ref) => {
  const {
    index,
    title,
    content,
    isVisible,
    isLoggedIn,
    activeIndex,
    onEndTour,
    onJoinNow,
    onPrevious,
    onNext
  } = props;

  const mainClass = classNames({
    [styles.main]: true,
    [styles['main--visible']]: isVisible,
  });

  return (
    <div className={mainClass} ref={ref}>
      <button className={styles.close} onClick={onEndTour}>
        <IconClose />
      </button>
      <div>
        <div className={styles.header}>
          {title}
        </div>
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
      <div className={styles.footer}>
        <div>
          {index ? (
            <button onClick={onPrevious}>Previous</button>
          ) : <div />}
        </div>
        <div className={styles.steps}>
          {STEPS_CONTENT.map((step, cardIndex) => (
            <span
              key={step.title}
              {...(cardIndex === activeIndex && { className: styles.activeStep })}
            />
          ))}
        </div>
        {index === STEPS_CONTENT.length - 1 ? (
          <div>
            {isLoggedIn ? (
              <button onClick={onEndTour}>End Tour</button>
            ) : (
              <button onClick={onJoinNow}>Join Now</button>
            )}
          </div>
        ) : (
          <div>
            <button onClick={onNext}>Next</button>
          </div>
        )}
      </div>
    </div>
  );
});

Card.propTypes = {
  index: PropTypes.number.isRequired,
  isVisible: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  activeIndex: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onEndTour: PropTypes.func.isRequired,
  onJoinNow: PropTypes.func.isRequired,
};

export default Card;
